import styled from 'styled-components';
import { Button, Checkbox as CB } from 'junto-ui';
import Colors from '@constants/Colors';

export const Wrapper = styled.div`
  padding: 56px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  @media (max-width: 576px) {
    height: 100vh;
    padding: 0px 24px;
  }
`;

export const Title = styled.h3`
  margin: 0;
  margin-bottom: 32px;
  color: ${Colors.darkSlate};
  font-size: 26px;
  line-height: 34px;
  text-align: center;
  width: 100%;
`;

export const Text = styled.p`
  max-width: 320px;
  margin: 0;
  margin-bottom: 32px;
  color: ${Colors.darkSlate};
  font-size: 16px;
  font-weight: 300;
  line-height: 22px;
  text-align: center;

  a {
    text-decoration: none;
    color: ${Colors.periwinkleStrong};
  }
`;

export const ConfirmButton = styled(Button)`
  width: 312px;
  height: 64px;
  margin-top: ${({ noMargin }) => (noMargin ? '0px' : '40px')};

  @media (max-width: 576px) {
    width: 100%;
  }
`;

export const Checkbox = styled(CB)`
  margin-bottom: 8px;

  > label:last-child {
    position: relative;
    top: 7px;
  }
`;

export const ErrorMessage = styled.p`
  margin: 0;
  font-size: 12px;
  font-weight: 300;
  color: #fe6666;
  line-height: 18px;
  position: relative;
`;

export const LinkButton = styled.button`
  background: none;
  padding: 0px;
  color: #9000ff;
  border: none;
  font-size: ${({ variant }) => (variant === 'checkbox' ? '14px' : '16px')};
  line-height: ${({ variant }) => (variant === 'checkbox' ? '18px' : '22px')};
  font-weight: 300;
  cursor: pointer;
`;
